import React, { Component } from "react";
import Slider from "react-slick";

import sliderOneImage from "../images/px-slider.jpg"
import sliderTwoImage from "../images/practice-revenue.jpg"
import sliderThreeImage from "../images/online-visibility.jpg"
import sliderFourImage from "../images/online-reputation.jpg"
import checkMark from "../images/black-checkmark.svg"

import "./card_carousel.scss"

export default class CardCarousel extends Component {
    render() {
      const settings = {
        // autoplay: true,
        // autoplaySpeed: 3000,
        // speed: 3000,
        rows: 1,
        lazyLoad: true,
        dots: true,
        speed: 500,
        infinite: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dotsClass: "slider-dots",
        appendDots: dots => (
            <div>
              <ul style={{ margin: "0px" }}> {dots} </ul>
            </div>
        ),
        customPaging: i => (
            <div></div>
        ),
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,

              }
            }
          ]
        };
      return (
        <section>
        <div className="card-carousel bg-white container">
          <div className="row justify-content-md-center">
            <div className="col-sm-12">
              <div className="slider-container">
              <Slider {...settings}>
                <article className="card" style={{ width: '305px' }}>
                    <div className="card-body d-flex px-0">
                      <img src={checkMark} alt="..." />
                      <h5 className="card-title"> Improve Your <strong>Patient Experience</strong></h5>
                      <div className="bg-primary"></div>
                      <p className="card-text"><small className="bg-primary"></small></p>
                    </div>
                    <img src={sliderOneImage} className="card-img-bottom" alt="..." />
                  </article>
                  <article className="card" style={{ width: '305px' }}>
                  <div className="card-body d-flex px-0">
                      <img src={checkMark} alt="..." />
                      <h5 className="card-title">Improve Your <strong>Practice Revenue</strong></h5>
                      <p className="card-text"><small className="bg-primary"></small></p>
                    </div>
                    <img src={sliderTwoImage} className="card-img-bottom" alt="..." />
                  </article>
                  <article className="card" style={{ width: '305px' }}>
                  <div className="card-body d-flex px-0">
                      <img src={checkMark} alt="..." />
                      <h5 className="card-title">Improve Your <strong>Online Visibility</strong></h5>
                      <p className="card-text"><small className="bg-primary"></small></p>
                    </div>
                    <img src={sliderThreeImage} className="card-img-bottom" alt="..." />
                  </article>
                  <article className="card" style={{ width: '305px' }}>
                  <div className="card-body d-flex px-0">
                      <img src={checkMark} alt="..." />
                      <h5 className="card-title" style={{color: '#474747'}}>Improve Your <strong>Online Reputation</strong></h5>
                      <p className="card-text"><small className="bg-primary"></small></p>
                    </div>
                    <img src={sliderFourImage} className="card-img-bottom" alt="..." />
                  </article>
                  </Slider>
              </div>
            </div>
           </div>
        </div>
        </section>
      );
    }
  }